import { useState, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MessageContainer from "./MessageContainer.js";
import Auth from "../Auth/Auth.js";
import ProtectedRoute from "./ProtectedRoute.js";
import App from "../App/App.js";
import ClientRoom from "../ClientRoom/ClientRoom.js";
import { MAX_DELAY } from "../../consts.js";

function Main() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setAdmin] = useState(false);
  const [isManager, setManager] = useState(false);
  const [isClient, setClient] = useState(false);
  const [isModer, setModer] = useState(false);
  const [username, setUsername] = useState("");
/*   const [clientWidth, setClientWidth] = useState(0); */

  const timeoutRef = useRef(null);

  const setupLogoutTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(handleLogout, MAX_DELAY);
  };

/*   useEffect(() => {
    const client = window.document.documentElement.clientWidth;
    setClientWidth(client);
  }, []); */

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--scrollbar", !isAdmin ? "block" : "none");
  }, [isAdmin]);

  useEffect(() => {
    const savedAuth = localStorage.getItem("isAuthenticated");
    const savedStatus = localStorage.getItem("status");
    const savedTimestamp = localStorage.getItem("ts");

    if (!savedTimestamp) return;

    const timePassed = Date.now() - parseInt(savedTimestamp);
    if (timePassed > MAX_DELAY) {
      handleLogout();
      return;
    }

    const timeLeft = MAX_DELAY - timePassed;
    timeoutRef.current = setTimeout(handleLogout, timeLeft);

    if (savedAuth === "true") {
      setIsAuthenticated(true);
    }
    setModer(+savedStatus > 2);
    setAdmin(+savedStatus > 3);
    setManager(+savedStatus === 2);
    setClient(+savedStatus === 1);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
      localStorage.setItem("ts", Date.now().toString());
      setupLogoutTimer();
    }
  };

  const handleLogout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("user");
    localStorage.removeItem("status");
    localStorage.removeItem("ts");
    setIsAuthenticated(false);
    setAdmin(false);
    setModer(false);
    setManager(false);
    setClient(false);
    setUsername("");
  };

  return (
    <Router>
{/*       {clientWidth < 800 ? (
        <h1
          style={{
            whiteSpace: "break-spaces",
            wordWrap: "break-word",
            width: "100vw",
          }}
        >
          На данный момент работа с сайтом возможна только в компьютерной версии.
          Спасибо
        </h1>
      ) : ( */}
        <div className="app">
          <Routes>
            <Route
              path="/auth"
              element={
                isAuthenticated ? (
                  <Navigate to="/" replace />
                ) : (
                  <>
                    <Auth
                      onLogin={handleLogin}
                      setAdmin={setAdmin}
                      setModer={setModer}
                      setManager={setManager}
                      setClient={setClient}
                      setUsername={setUsername}
                    />
                    <MessageContainer />
                  </>
                )
              }
            />

            <Route
              path="/"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <>
                    {isManager || isModer || isAdmin ? (
                      <App
                        handleLogout={handleLogout}
                        isAdmin={isAdmin}
                        isModer={isModer}
                      />
                    ) : isClient ? (
                      <ClientRoom
                        handleLogout={handleLogout}
                        username={username}
                        key={username}
                      />
                    ) : null}
                  </>
                  <MessageContainer />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/auth" replace />} />
          </Routes>
        </div>
{/*       )} */}
    </Router>
  );
}

export default Main;
